import {
  FETCH_SHARE_USERS_REQUEST,
  FETCH_SHARE_USERS_SUCCESS,
  FETCH_SHARE_USERS_FAILURE,
} from "../constants/actionTypes";

const initialState = {
  loading: false,
  loaded: false,
  data: [],
  error: null,
};

const shareUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHARE_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SHARE_USERS_SUCCESS:
      return { ...state, loading: false, loaded: true, data: action.payload };
    case FETCH_SHARE_USERS_FAILURE:
      return { ...state, loading: false, loaded: false, error: action.error };
    default:
      return state;
  }
};

export default shareUsersReducer;
